import React from 'react';
import _ from 'lodash';
import styles from './styles.module.scss';
import { targetedSkills } from 'utils/competency-data';
import AudienceSegmentModal from 'components/shared/landing/audience-segment-modal';
import EncyclopediaBreadcrumbs from './encyclopedia-breadcrumbs';

export default class TargetedSkill extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      audienceSegmentModalOpen: false,
      redirectToEducator: false,
      redirectToParent: false,
    };

    this.onClickAudienceSegmentModal =
      this.onClickAudienceSegmentModal.bind(this);
    this.onCloseAudienceSegmentModal =
      this.onCloseAudienceSegmentModal.bind(this);
  }

  onClickAudienceSegmentModal() {
    this.setState({ audienceSegmentModalOpen: true });
  }

  onCloseAudienceSegmentModal() {
    this.setState({ audienceSegmentModalOpen: false });
  }

  render() {
    const { targetedSkill } = this.props.match.params;
    const { audienceSegmentModalOpen } = this.state;

    const selectedTargetedSkill = targetedSkills[targetedSkill];
    const breadcrumbTitle = _(selectedTargetedSkill.category)
      .split('-')
      .map(skillFragment => _.capitalize(skillFragment))
      .join(' ');

    return (
      <div className={styles.encyclopediaContainer}>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <EncyclopediaBreadcrumbs
                paths={[
                  { title: 'Sel Enyclopedia', link: '/sel-encyclopedia' },
                  {
                    title: breadcrumbTitle,
                    link: `/sel-encyclopedia/competencies/${selectedTargetedSkill.category}`,
                  },
                  { title: selectedTargetedSkill.title },
                ]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-7">
              <h1 className={styles.skillHeader}>
                {selectedTargetedSkill.title}
              </h1>
              <p className="my-3">
                <strong>Definition:</strong>
                <br />
                {selectedTargetedSkill.description}
              </p>
              <p className="my-3">
                <strong>How Unyted Does It:</strong>
                <br />
                {selectedTargetedSkill.howUnytedDoesIt}
              </p>
            </div>
            <div className="col-12 col-md-5">
              <div className={styles.skillSidebar}>
                <div className={styles.ctaBox}>
                  <h3 className="text-apple">Real Life Application</h3>
                  <img
                    className={styles.icon}
                    src={selectedTargetedSkill.icon}
                  />
                  <p>{selectedTargetedSkill.realLifeApplication}</p>
                  <div className={styles.encyclopediaCta}>
                    <button
                      onClick={this.onClickAudienceSegmentModal}
                      className="blue w-100"
                    >
                      Put it into practice!
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {audienceSegmentModalOpen && (
              <AudienceSegmentModal
                onClose={this.onCloseAudienceSegmentModal}
                onSelectEducatorURL="/educators"
                onSelectParentURL="/parents"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
